import { leftPad } from './numberFormat';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';

interface Erro {
  message: string;
}

// Estado do hook que pode conter o error
interface QueryStatusLike {
  error?: string | FetchBaseQueryError | SerializedError;
}

const formatErrorMessage = (input?: string | FetchBaseQueryError | SerializedError | QueryStatusLike): string => {
  let error: string | FetchBaseQueryError | SerializedError | undefined;

  // Caso input seja objeto com .error
  if (input && typeof input === 'object' && 'error' in input) {
    error = input.error;
  } else {
    error = input as string | FetchBaseQueryError | SerializedError | undefined;
  }

  if (!error) return '';

  // Caso seja string simples
  if (typeof error === 'string') {
    return error;
  }

  let msgBox = '';

  // Caso seja erro de rede
  if ('status' in error) {
    if (error.status === 'FETCH_ERROR') {
      msgBox = 'Erro de conexão ao solicitar o serviço! Verifique sua internet.';
    } else {
      msgBox = `STATUS: ${error.status}`;

      if ('data' in error && error.data) {
        const data = error.data as Erro | Erro[];
        if (Array.isArray(data)) {
          data.forEach((e, i) => {
            msgBox += `\nErro (${leftPad(i + 1, 5)}): ${e.message}`;
          });
        } else if (data?.message) {
          msgBox += `\nErro: ${data.message}`;
        }
      }
    }
  }
  // Caso seja SerializedError
  else if ('message' in error) {
    msgBox += `\n${error.message}`;
  }

  return msgBox || 'Erro desconhecido.';
};

export default formatErrorMessage;
